function voicePrompt(text) {
    new Audio('http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=4&text=你好啊，听起来好憨啊' + text).play();
}

export {
    voicePrompt
}
